<template>
    <!-- Attributes fall through to b-dropdown, so callers can use any of its props
         (size, block, disabled, dropup, ...) without this component declaring each one.
         $attrs is bound last so a caller can still override any default set here.

         `right` is a default rather than a per-page choice: this control sits at the
         right edge of every report toolbar, and bootstrap-vue leaves the menu in the
         layout (display:block, position:absolute) even while closed. Left-aligned, its
         160px overhangs the viewport and the page carries a horizontal scrollbar before
         anyone opens the dropdown. Right-aligning anchors the menu's right edge to the
         button's, so it opens inward and adds no scroll. -->
    <b-dropdown variant="success" text="Export" right v-bind="$attrs">
        <b-dropdown-item @click="$emit('export-pdf')">
            <i class="fa fa-fw fa-lg fa-file-pdf" />
            PDF
        </b-dropdown-item>
        <b-dropdown-item @click="$emit('export-csv')">
            <i class="fa fa-fw fa-lg fa-file-csv" />
            CSV
        </b-dropdown-item>
    </b-dropdown>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';

@Component({ name: 'ExportDropdown', inheritAttrs: false })
export default class ExportDropdown extends Vue {
}
</script>
